import { useAtomValue } from 'jotai';
import { domain } from 'modules/data';
import { memo, useEffect, useState } from 'react';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { syncAllBudgetsPageState } from '../../../../states';
import BudgetActionsMenu from '../../../BudgetActionsMenu/BudgetActionsMenu';
import { BudgetTile } from '../../../BudgetTile/BudgetTile';
import { BudgetParams } from '../BudgetParams/BudgetParams';
import { BudgetListItemProps } from './BudgetListItem.types';

export const BudgetListItem = memo<BudgetListItemProps>((props) => {
    const { budget } = props;

    const syncAllBudgetsState = useAtomValue(syncAllBudgetsPageState);
    const company = useCompanyBasedOnUrl();
    const { hasActiveIntegration } = company.flags;
    const { name, isEnabled, syncStatus, origin } = budget;
    const [isLoading, setIsLoading] = useState(syncStatus === domain.BudgetSyncStatus.Synchronizing);
    const synchronizationFailed = syncStatus === domain.BudgetSyncStatus.SynchronizationFailed;

    useEffect(() => {
        const newSyncInProgress =
            origin !== domain.BudgetOrigin.Manual &&
            (syncStatus === domain.BudgetSyncStatus.Synchronizing || syncAllBudgetsState);

        setIsLoading(newSyncInProgress);
    }, [origin, setIsLoading, syncAllBudgetsState, syncStatus]);

    return (
        <BudgetTile
            name={name}
            isEnabled={isEnabled && hasActiveIntegration}
            isSyncInProgress={isLoading}
            isSyncFailed={synchronizationFailed}
            origin={origin}
            actionsMenu={
                <BudgetActionsMenu
                    company={company}
                    budget={budget}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                />
            }
            budgetParams={<BudgetParams company={company} budget={budget} />}
        />
    );
});

BudgetListItem.displayName = 'BudgetListItem';
